const DEFAULT_API_BASE = 'https://backend.thescandal.co.za';

function normalizeBase(url) {
  return String(url || '').trim().replace(/\/$/, '');
}

export function getApiBase() {
  const runtimeBase =
    typeof window !== 'undefined' && window.__THESCANDAL_CONFIG__
      ? window.__THESCANDAL_CONFIG__.API_BASE_URL
      : '';

  return normalizeBase(runtimeBase || process.env.REACT_APP_API_URL || DEFAULT_API_BASE);
}
